import React, { useEffect } from 'react';
import { Stack } from '@shopify/polaris';

import OnboardingSection from './OnboardingSection';
import PageViewSection from './PageViewSection';
import SubscriptionStatusSection from './SubscriptionStatusSection';

const HomePanel = ({
	shared,
	lastSyncStore,
	products,
	syncingProducts,
	collections,
	pages,
	articles,
}) => {
	const { setPrimaryAction, setSecondaryActions } = shared;

	useEffect(() => {
		setPrimaryAction(null);
		setSecondaryActions([]);
	}, []);

	return (
		<Stack vertical>
			<OnboardingSection />
			<SubscriptionStatusSection
				shared={shared}
				lastSyncStore={lastSyncStore}
				products={products}
				syncingProducts={syncingProducts}
				collections={collections}
				pages={pages}
				articles={articles}
			/>
			<PageViewSection shared={shared} />
		</Stack>
	);
};

export default HomePanel;
